import { render } from "./eduResearchStat.vue?vue&type=template&id=6efe7642&scoped=true"
import script from "./eduResearchStat.vue?vue&type=script&lang=js"
export * from "./eduResearchStat.vue?vue&type=script&lang=js"

import "./eduResearchStat.vue?vue&type=style&index=0&id=6efe7642&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efe7642"]])

export default __exports__